const gotrams = [
  "Aananda Bairavi Mahirishi",
  "Aashritha Maharishi",
  "Aasuvalaayana Maharishi",
  "Aathreya Maharishi",
  "Acchudha Maharishi",
  "Aditha Maharishi",
  "Agarcha Maharishi",
  "Agastya Maharishi",
  "Amara Maharishi",
  "Anjana Devarishi",
  "Aritsha Maharishi",
  "Ashra Maharishi",
  "Asideva Maharishi",
  "Atchaya Devarishi",
  "Athiri Maharishi",
  "Athivi Maharishi",
  "Baaga Maharishi",
  "Baavaja Maharishi",
  "Babaala Maharishi",
  "Bagadeva Maharishi",
  "Bagathaalpiya Maharishi",
  "Bharadhwaja Maharishi",
  "Bhaskara Maharishi",
  "Bheemaga Maharishi",
  "Bibbaala Maharishi",
  "Boga Maharishi",
  "Bowlashya Maharishi",
  "Brammaanda Maharishi",
  "Brugu Maharishi",
  "Brundha Maharishi",
  "Brungi Maharishi",
  "Chandirakula Maharishi",
  "Chitravargha Maharishi",
  "Dadeesi Maharishi",
  "Daseetha Maharishi",
  "Deva Maharishi",
  "Devadatta Maharishi",
  "Devala Maharishi",
  "Devaraatha Maharishi",
  "Dhaivakya Maharishi",
  "Dhaivaraatha Maharishi",
  "Dhurvaasa Maharishi",
  "Dowbaaya Maharishi",
  "Durmabindhu Maharishi",
  "Gouthama Maharishi",
  "Gouthsya Maharishi",
  "Haala Hala Maharishi",
  "Haritha Maharishi",
  "Indirathooimam Deva Maharishi",
  "Jaabaali Maharishi",
  "Jaalaga Maharishi",
  "Jaantha Maharishi",
  "Jamadhagni Maharishi",
  "Jambaari Maharishi",
  "Jambu Maharishi",
  "Jamu Maharishi",
  "Janaga Maharishi",
  "Jayamuni Maharishi",
  "Kaabaala Maharishi",
  "Kaalava Maharishi",
  "Kaamuga Maharishi",
  "Kaana Maharishi",
  "Kaangeya Maharishi",
  "Kaarkeya Maharishi",
  "Kaasiyaba Maharishi",
  "Kaathya Maharishi",
  "Kaathya Kaathyaayana Deva Maharishi",
  "Kabila Maharishi",
  "Kanaga Maharishi",
  "Kanva Maharishi",
  "Karasaka Maharishi",
  "Karthikeya Maharishi",
  "Kavusa Maharishi",
  "Kindhama Maharishi",
  "Kirudhu Maharishi",
  "Kowndalya Maharishi",
  "Kowshika Maharishi",
  "Krounja Maharishi",
  "Krounjalya Maharishi",
  "Ksema Ksemandha Ksemandra Maharishi",
  "Kudumba Maharishi",
  "Kumba Sambava Maharishi",
  "Kusha Maharishi",
  "Kuthaala Maharishi",
  "Kuthsaga Maharishi",
  "Maalka Maharishi",
  "Maandavya Maharishi",
  "Maanya Maharishi",
  "Maarkandeya Maharishi",
  "Maithrathuima Maharishi",
  "Maithreya Maharishi",
  "Mallaa Deva Maharishi",
  "Mandira Deva Maharishi",
  "Manjula Maharishi",
  "Manmadha Maharishi",
  "Manorama Maharishi",
  "Manu Maharishi",
  "Manuvaama Maharishi",
  "Mareesi Maharishi",
  "Mathanga Maharishi",
  "Mathsaya Maharishi",
  "Mrukandu Maharishi",
  "Mruthyunjaya Maharishi",
  "Muga Maharishi",
  "Muthkala Maharishi",
  "Muthu Maharishi",
  "Muvvala Maharishi",
  "Naagaradeva Maharishi",
  "Naamadeva Maharishi",
  "Naaratha Maharishi",
  "Naikkiyadeva Maharishi",
  "Padma Maharishi",
  "Paraasara Maharishi",
  "Parvatha Maharishi",
  "Pathanjali Maharishi",
  "Pigi Maharishi",
  "Pirugu Maharishi",
  "Pirungadeva Maharishi",
  "Pirungi Maharishi",
  "Prathaapa Maharishi",
  "Pulasthiya Maharishi",
  "Punardeva Maharishi",
  "Pundareega Maharishi",
  "Puratcha Maharishi",
  "Purukootha Maharishi",
  "Pusha Maharishi",
  "Raaja Maharishi",
  "Raajakulatamahadeva Maharishi",
  "Ragasya Maharishi",
  "Raippiya Maharishi",
  "Rippilaaya Maharishi",
  "Rishya Maharishi",
  "Rukdeva Maharishi",
  "Rushya Maharishi",
  "Ruthvija Maharishi",
  "Saalihotra Maharishi",
  "Saanaka Maharishi",
  "Saandilya Maharishi",
  "Saangiya Maharishi",
  "Saangiyaayana Maharishi",
  "Saanthirayana Maharishi",
  "Saararatha Maharishi",
  "Saarathvandhu Maharishi",
  "Sachithaanandha Maharishi",
  "Sadhanandha Maharishi",
  "Sadhumuga Maharishi",
  "Saguni Maharishi",
  "Sambu Maharishi",
  "Sanadhana Deva Maharishi",
  "Sanaga Sanandha Maharishi",
  "Sanathkumara Maharishi",
  "Sanathujatha Maharishi",
  "Sandhana Maharishi",
  "Sangalya Maharishi",
  "Sangu Maharishi",
  "Sankarshana Maharishi",
  "Sarasadampa Maharishi",
  "Sarasujaatha Maharishi",
  "Sarva Maharishi",
  "Savithira Maharishi",
  "Sirukka Maharishi",
  "Sirungi Maharishi",
  "Siva Sivagnana Maharishi",
  "Somagalya Maharishi",
  "Somaka Maharishi",
  "Somakalya Maharishi",
  "Somakula Maharishi",
  "Somendra Maharishi",
  "Somothbava Maharishi",
  "Soorasowva Maharishi",
  "Sowkiya Maharishi",
  "Sowlapya Maharishi",
  "Sowlasthiya Maharishi",
  "Sownaga Maharishi",
  "Suga Maharishi",
  "Sugothbava Maharishi",
  "Sukreeva Maharishi",
  "Suryakula Maharishi",
  "Suthmala Maharishi",
  "Suyambudeva Saatvikadeva Maharishi",
  "Swayumbuva Maharishi",
  "Syaalaga Maharishi",
  "Thaalcha Maharishi",
  "Thaalpiya Maharishi",
  "Thalappiyadeva Maharishi",
  "Thamba Maharishi",
  "Thamravarna Maharishi",
  "Thatha Maharishi",
  "Thirunabindhu Maharishi",
  "Thrayambaga Maharishi",
  "Thuthsa Maharishi",
  "Thuvaipaayana Maharishi",
  "Thuvanthadeva Maharishi",
  "Ubamanyu Maharishi",
  "Ushana Maharishi",
  "Vaalakilya Maharishi",
  "Vaamadeva Maharishi",
  "Vaaru Maharishi",
  "Vaaruna Maharishi",
  "Valmiki Maharishi",
  "Vanjula Maharishi",
  "Varathantha Maharishi",
  "Vashishta Maharishi",
  "Vasudeva Maharishi",
  "Vatsa Maharishi",
  "Vebana Maharishi",
  "Veda Maharishi",
  "Veerathanthi Maharishi",
  "Vidya Maharishi",
  "Vikgnana Maharishi",
  "Vishwamithra Maharishi",
  "Vyaakrapaatha Maharishi",
  "Vyasa Maharishi",
  "Yaakgnya Deva Maharishi",
  "Yaaknjyavalkiya Maharishi",
  "Yogabrindha Maharishi",
];

export default gotrams;
